export enum CustomRoutes {
  InteractionsFeed = 'interactions-feed',
  Organismes = 'organismes',
  Interlocuteurs = 'interlocuteurs',
  Interactions = 'interactions',
  TableauDeBord = 'tableau-de-bord',
  AccesNonAutorise = 'acces-non-autorise',
  AccessRights = 'access-rights',
}
